import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import SimpleHeader from 'components/header/SimpleHeader'
import { Icon } from 'stories/Icons'
import { useApiQuery } from 'hooks/useApiQuery';
import { useApiMutation } from 'hooks/useApiMutation';
import { getTicketDetailsAction, markSeenAction, sendMessageAction } from 'api/actions/SupportActions';
import SupportChatBubble from 'pages/home/support/SupportChatBubble';
import moment from 'moment';
import SupportChatActions from './SupportChatActions';
import useToastify from 'hooks/useToastify';
import Spacer from 'components/Spacer/Spacer';

function SupportChat() {
  const history = useHistory();
  const { ticket_id } = useParams();

  const { showAlert } = useToastify();

  const { payload: ticketDetailsFromApi, loading: isFetchingTicketDetails, query: refreshTicketDetailsQuery } = useApiQuery(
    getTicketDetailsAction(ticket_id)
  );

  const { query: markSeenQuery } = useApiQuery(
    markSeenAction(ticket_id)
  );

  const { mutate: callSendSupportMessage, loading: isSendingSupportMessage } = useApiMutation(sendMessageAction);
  
  const MAX_FILES = 4;
  const template = Array.from(Array(MAX_FILES)).map((_) => ({
    uri: "",
    file: "",
    data: "",
  }));

  const [fileArray, setFileArray] = useState(template);
  const [inputText, setInputText] = useState("");
  const messagesEndRef = useRef(null);


  
  const handleBack = () => {
    if (history?.length > 1) {
      history.goBack();
    } else {
      history.replace("/home/support");
    }
  };

  const reload = () => {
    refreshTicketDetailsQuery();
    markSeenQuery();
  };

  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView();
  };

  useEffect(() => {
    if (ticketDetailsFromApi?.conversations?.length) {
      scrollToBottom();
    }
  }, [ticketDetailsFromApi?.conversations]);

  async function onSend(fileArray) {
    try {
      const supportedFileFormats = [".pdf", ".jpg", ".jpeg", ".png"];
      const formData = new FormData();
      const messageText = inputText.trim();
      // Allow empty message if there are attachments
      const hasAttachments = fileArray && fileArray.length > 0;
      const finalMessage = hasAttachments && !messageText ? " " : messageText;
      formData.append("conversation", JSON.stringify({ message: finalMessage }));

      if (fileArray) {
        const getFileExtension = (uri) => {
          if (!uri) return '';
          const lastDot = uri.lastIndexOf('.');
          return lastDot !== -1 ? uri.substring(lastDot).toLowerCase() : '';
        };
        
        const unsupportedFiles = fileArray?.filter(
          (el) => {
            const extension = getFileExtension(el?.uri);
            return extension && !supportedFileFormats.includes(extension);
          }
        );
        
        if (unsupportedFiles?.length > 0) {
          showAlert(`These file type(s) are not supported. Please convert to PDF or use images(.jpg, .jpeg, .png) instead.`, "error");
          return;
        }
        
        const allowedFiles = fileArray?.filter(
          (el) => {
            const extension = getFileExtension(el?.uri);
            return supportedFileFormats.includes(extension);
          }
        );

        if (allowedFiles?.length) {
          allowedFiles.forEach((file, index) => {
              formData.append(`attachments[]`, file?.file);
          });
        }
      }
      const result = await callSendSupportMessage({
        ticketId: ticket_id,
        payload: formData,
      });

      if (result?.payload?.message) {
        setInputText("");
        setFileArray(template);
        reload();
        scrollToBottom();
      }else if (result?.payload?.error) {
        showAlert(result?.payload?.error, "error");
        reload();
      }
    } catch (error) {
      showAlert("Failed to send message. Please try again.", "error");
    }
  }


  return (
    <div className="h-full overflow-x-hidden overflow-y-auto bg-alternativeWhite">
      <SimpleHeader
        title={ticketDetailsFromApi?.subject}
        bgColor="bg-alternativeWhite"
        showBackButton
        onBackButtonClick={handleBack}
        className={"border-l border-r border-t wrapper"}
        parentClass={"wrapper"}
        rightActionView={
          <button onClick={reload}>
            <Icon name={"refresh"} loading={isFetchingTicketDetails} />
          </button>
        }
      />
      <div className="relative h-eliminateHeader wrapper">
        <div className="h-full">
          <div className="min-h-full px-8 bg-white border-l border-r">
            <div className="py-8">
              {ticketDetailsFromApi?.conversations?.map((conversation, index) => (
                <SupportChatBubble key={index} showDateBanner={
                  index === 0 || 
                  !moment(conversation?.created_at).isSame(
                    moment(ticketDetailsFromApi?.conversations?.[index - 1]?.created_at), 
                    'day'
                  )
                } conversation={conversation} avatars={ticketDetailsFromApi?.avatars} />
              ))}
              <Spacer height={150} />
              <div ref={messagesEndRef} />
            </div>
          </div>
        </div>
        <SupportChatActions
          isQueryClosed={ticketDetailsFromApi?.status === "closed"}
          onSend={onSend}
          fileArray={fileArray}
          setFileArray={setFileArray}
          MAX_FILES={MAX_FILES}
          sendingMessage={isSendingSupportMessage}
          value={inputText}
          onChangeText={setInputText}
        />
      </div>
    </div>
  )
}

export default SupportChat